export const reviewList = [
    {
        country: 'USA',
        flagIcon: '🇺🇸',
        content: `I have 10K on my Nushings right now. I can honestly say 
        this is the best innovation that has come out of ADVrider for the 
        R1150GS (and there have been some great ADV inmate created parts 
        created). They absolutely rock, my back end is still rock 
        solid with no play and I put the big bike through it's paces. 
        These are brilliant, don't even think about stock bearings again. `
    },
    {
        country: 'USA',
        flagIcon: '🇺🇸 ',
        content: `My new Nylager Nushings are now installed in my 2000 R1150GS. Installation was painless `
    }, {
        country: 'Lithuania',
        flagIcon: '🇱🇹',
        content: `Due to customs/post office one nushing was missing in my
       first set, MFOL sent a new set without any questions asked 
       and did not accept the payment for it. This is a superb 
      service for a great replacement part, easily recommended.`
    },
    {
         country: 'USA',
        flagIcon: '🇺🇸 ',
        content: `Well made, good price, Matt answered all questions
                 quickly and shipping was fast.. I will recommend 100%`
    },
    {
         country: 'USA',
        flagIcon: '🇺🇸 ',
        content: `Just ordered a set, great alternative to the outrageously priced OEM.`
    },
    {
         country: 'USA',
        flagIcon: '🇺🇸 ',
        content: `The Nylager Nushings are serving me well! No more worries about submersion and I rode back from 4 days of punishment. :)`
    },  
    {
         country: 'USA',
        flagIcon: '🇺🇸 ',
        content: `Thanks Again! MFOL!`
    },
    {
        country: 'USA',
        flagIcon: '🇺🇸',
        content: `Many thanks for my set of nushings, 
        not a single hitch going in and first test ride was perfect. 
        The set of instructions for installation was very well written
         and easy to understand. Will hit the road to AK again in June 
         and that will prove to be a great shake down for the nushings) 
         They are so well designed for those pivots, I will no longer 
          worry about any needle bearings going bad.`
    },
    {
         country: 'USA',
        flagIcon: '🇺🇸 ',
        content: `Many thanks`
    },
    {
        country: 'Scottland',
        flagIcon: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
        content: `The nushings i installed last Sept now 
        have a bit over 20,000 mi on them and still 
        working great in my 2000 RT. I had no issues 
        installing them and they seem to be holding 
        up with no issues. About 50% with passenger and 
        camping gear so get a decent workout. have recommended 
        them to a couple guys i met. Arrived in the UK only a few days after payment`
    },
    
];



export const modelSet = ['R1100GS', 'R1150GS','K1200GT', 'K1200RS', 'R100R', 'R100', 'R1100R',
                 'R850R', 'R1100RS', 'R1100S', 'R1100RT', 'R850RT', 
                  'R80GS', 'K100RS', 'K1100LT', 'K1100RS', 'K1200LT', 'K1200RS',
                    'R1150RS', 'R1150RT', 'R1150R', 'R850R',
                   'R100GS (except 1988/1989)',]; 


export const InstallImages= [
    {
      url: '../assets/install/install 1.png',
      caption: 'Install 1'
    },
    {
      url: '../assets/install/install 2.png',
      caption: 'Install 2'
    },
    {
      url: '../assets/install/install 3.jpg',
      caption: 'Install 3'
    },
    {
      url: '../assets/install/nushings installed.jpeg',
      caption: 'Install 4'
    }];

    export const galleryImages= [
        {
          url: '../assets/gallery/image 1.jpg',
          caption: 'Image 1'
        },
        {
            url: '../assets/gallery/image 2.jpg',
            caption: 'Image 2'
          },
          {
            url: '../assets/gallery/image 3.jpg',
            caption: 'Image 3'
          },
          {
            url: '../assets/gallery/image 4.jpg',
            caption: 'Image 4'
          },
          {
            url: '../assets/gallery/image 5.jpg',
            caption: 'Image 5'
          },
          {
            url: '../assets/gallery/image 6.jpg',
            caption: 'Image 6'
          },
          {
            url: '../assets/gallery/image 7.jpg',
            caption: 'Image 7'
          },
          {
            url: '../assets/gallery/image 8.jpg',
            caption: 'Image 8'
          },
          {
            url: '../assets/gallery/image 9.jpg',
            caption: 'Image 9'
          },
          {
            url: '../assets/gallery/image 10.jpg',
            caption: 'Image 10'
          },
          {
            url: '../assets/gallery/image 11.jpg',
            caption: 'Image 11'
          }
        ];


// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/webData.ts